
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class WineTypeView extends Vue {
  public name: string = "WineTypeView";
}
